<template>
  <section id="page-adventure" class="mdl-grid adv-content" >
    <div id="introductory-page" style="color: white;text-align: left; background-color: rgba(255,255,255,0.1); padding: 5px;" v-if="!user" class="mdl-cell mdl-grid mdl-cell--12-col">
      <div class="mdl-cell mdl-grid mdl-cell--8-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
        <h4 class="mdl-cell--12-col" style="margin-left: 15px;">Create, Play and Share your own Adventures</h4>
        <div class="mdl-cell mdl-cell--12-col" style="display: inline: block; white-space:nowrap; text-overflow: ellipsis; overflow: hidden;">
          <router-link to="/login" class="mdl-button mdl-button--raised" style="margin: 0 15px 0px 10px; background-color: white;">SIGN IN</router-link>  to start creating and playing!
        </div>
        <div id="introductory-page-steps" 
            class="mdl-cell mdl-cell--12-col mdl-grid" 
            style="background-color: rgba(255,255,255,0.1); text-align: center; border-radius: 5px; padding-top: 5px; padding-bottom: 5px;">
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
            <i class="material-icons" style="position: relative; top: 5px;">widgets</i> Create Objects 
          </div>
          <i class="material-icons mdl-cell mdl-cell--1-col mdl-cell--hide-tablet mdl-cell--hide-phone" style="position: relative; top: 5px;">keyboard_arrow_right</i>
          <i class="material-icons mdl-cell mdl-cell--12-col mdl-cell--hide-desktop">keyboard_arrow_down</i>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
            <i class="material-icons" style="position: relative; top: 5px;">nature_people</i> Compose Stages
          </div>
          <i class="material-icons mdl-cell mdl-cell--1-col mdl-cell--hide-tablet mdl-cell--hide-phone" style="position: relative; top: 5px;">keyboard_arrow_right</i>
          <i class="material-icons mdl-cell mdl-cell--12-col mdl-cell--hide-desktop">keyboard_arrow_down</i>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone">
            <i class="material-icons" style="position: relative; top: 5px;">device_hub</i> Build a Timeline
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-grid mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone" style="background-color: black;">
        <iframe width="100%" height="200" src="https://www.youtube.com/embed/OUH2FQaBcnM" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
    <div v-if="user && !hideTip" class="mdl-cell mdl-cell--12-col" style="background-color: rgba(255, 255, 255, 0.1); text-align: right; padding: 5px; margin: -10px 0px 8px 0px;">
      <div @click="hideTips" class="mdl-button" style="font-size: smaller; margin-right: 3px; opacity: 0.5;"><i class="material-icons">visibility_off</i> hide this</div>
      <router-link class="mdl-button mdl-button--raised" style="background-color: white;" to="/editor">
        <i class="material-icons">edit</i> Adventure Editor</router-link>
    </div>
    <div v-for="item in itemsByDate" class="mdl-cell mdl-cell--stretch mdl-shadow--2dp mdl-cell--4-col mdl-cell--12-col-phone">
      <div class="mdl-card" style="width: 100%;"> 
        <div v-if="item.cover" class="mdl-card__title" :style="'background-color: #777777; background-image: url('+item.cover+'); padding: 28.125% 0 28.125% 0; background-repeat: no-repeat; background-size: contain;  background-position: center;'">
        </div>
        <div v-else class="mdl-card__title" style="display: inline; background-color: #ccc; color: #999; font-size: 24px; font-weight: bolder; height: 0px; width: 100%; padding: 28.125% 0 28.125% 0; text-align: center;">
          NO COVER
        </div>
        <div class="mdl-card__title">
          <h2 class="mdl-card__title-text">{{item.name}}</h2>
        </div>
        <div class="mdl-card_subtitle">
          By <router-link to="/">{{item.owner.name}}</router-link> - {{ item.datePublished | moment("Do MMM YYYY") }}    
        </div>
        <div class="mdl-card__supporting-text">
          {{item.description}}
        </div>
        <div class="mdl-card__actions mdl-card--border">
          <router-link v-if="user" :to="('/play/'+item.key)" class="mdl-cell--12-col-phone mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            <i class="material-icons">play_arrow</i> {{getPlayText(item.key, savesInfo)}}
          </router-link>
          <router-link v-else to="login" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            <i class="material-icons">play_arrow</i> Login to Play
          </router-link>
          <button v-if="user" class="mdl-cell--12-col-phone mdl-button mdl-js-button mdl-js-ripple-effect" @click="showDialog('shareAdventure', item.key)">
                <i class="material-icons">share</i>
                Share
            </button>
        </div>
      </div>
    </div>
    <div v-if="!isShowingAll" class="adv-next-page-button">
      <button @click="showMore" class="mdl-button mdl-js-button mdl-button--raised mdl-button--fab">
        <i class="material-icons" >expand_more</i>
      </button>
    </div>
    <div v-else class="adv-next-page-button" style="font-style: italic; color: white; opacity: 0.3">
    <div style="border-top: dashed 1px white; opacity:0.5; width: 90%; margin-left: 5%; height: 5px; margin-top: 15px;"></div> 
      Showing all adventures.
    </div>
     <dialog class="mdl-dialog shareAdventure">
      <div class="mdl-dialog__title">Share this adventure</div>
      <div class="mdl-dialog__content">
        <p>
          Share this URL with your friends:
          <input id="dialog_copy_text" class="mdl-textfield" style="width: 100%;" :value="'http://studio.adventify.com/#/play/'+selectedId" ></input>
            <button class="mdl-button mdl-button--raised" onclick="document.querySelector('#dialog_copy_text').select(); document.execCommand('copy'); document.querySelector('#dialog_copy_result').innerHTML = 'URL copied to clipboard!';" style="position: relative; top: 5px; ">SELECT AND COPY</button>
            <div style="position: relative; float: left;" id="dialog_copy_result">
          </div>
        </p>
      </div>
      <div class="mdl-dialog__actions mdl-dialog__actions">
        <button type="button" class="mdl-button close">CLOSE</button>
      </div>
    </dialog>
  </section>
</template>
<script>

import Vue from 'vue'
import TextTools from './TextTools.js';

var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);
Vue.use(require('vue-moment'));

var sectionFeed

export default{
  data: () => ({
      textTools: {},
      user: null,
      currentPage: 0,
      adventuresPerPage: 6,
      lastItem: null,
      items: {},
      isShowingAll: false,
      selectedId: null,
      savesInfoRef: {},
      savesInfo: {},
      hideTip: false
  }),
  created(){
      if(this.$cookie.get('hideTip')){
        this.hideTip = true;
      }
      sectionFeed = this;
      this.textTools = TextTools;
      this.user = window.firebase.auth().currentUser;
      window.firebase.auth().onAuthStateChanged((user) => {
        sectionFeed.user = user;
        if(user){
          sectionFeed.loadSaves(user.uid);
        }
      });
      this.getAdventures();
  },
  methods: {
    hideTips(){
      this.hideTip = true;
      this.$cookie.set('hideTip', true, { expires: '3D' });
      var data = {message: 'You can still access the editor from the ⋮ top right menu' };
      document.querySelector('#snackbar').MaterialSnackbar.showSnackbar(data);
    },
    getPlayText(advId, savesInfo){
      if(savesInfo[advId]){
        if(savesInfo[advId].finished){
          return 'Play Again';
        }
        return 'Continue';
      }
      return 'Play';
    },
    loadSaves(uid){
      this.savesInfoRef = window.firebase.database().ref('savesInfo/'+uid);
      this.savesInfoRef.on('value',function(snapshot) {
          sectionFeed.savesInfo = snapshot.val();
      });
    },
    getAdventures(){
      var advRef = window.firebase.database().ref('publishedAdventures').
        orderByChild('datePublished').
        limitToLast(this.adventuresPerPage);
      advRef.on('value',function(snapshot) {
          var newItems = snapshot.val();
          if(Object.keys(newItems).length<sectionFeed.adventuresPerPage+1) sectionFeed.isShowingAll = true;
          sectionFeed.lastItem = newItems[Object.keys(newItems)[0]].datePublished;
          sectionFeed.items = newItems;
      });
    },
    showMore(){
      var advRef = window.firebase.database().ref('publishedAdventures').
        orderByChild('datePublished').
        limitToLast(this.adventuresPerPage+1).
        endAt(this.lastItem);
        console.log(this.lastItem);
      advRef.on('value',function(snapshot) {
          var newItems = snapshot.val();
          if(Object.keys(newItems).length<sectionFeed.adventuresPerPage+1) sectionFeed.isShowingAll = true;
          sectionFeed.lastItem = newItems[Object.keys(newItems)[0]].datePublished;
          console.log(newItems);
          Object.assign(sectionFeed.items, newItems);
      });
    },
    showDialog(dialogId, selectedId){
        this.selectedId = selectedId;
        var dialog = document.querySelector('dialog.'+dialogId);
        if (!dialog.showModal) {
          dialogPolyfill.registerDialog(dialog);
        }
        dialog.showModal();
        if(!dialog.listened){
          dialog.querySelector('.close').addEventListener('click', function() {
            dialog.close();
          });
        }
        dialog.listened = true;
    }
  },
  computed: {
    itemsByDate(){
      var currentItems = this.items;
      var result = Object.keys(currentItems).map(function(e) {
        var item = currentItems[e];
        item.key = e; 
        return item;
      });
      return result.sort(function(a,b){
        return b.datePublished - a.datePublished
      });
    }
  }
}

</script>
<style>
  
  #page-adventure  .mdl-card_subtitle{
    margin: -14px 18px 0px 18px;
    padding: 0px;
    font-size: 0.8em;
    opacity: 0.66;
  }
</style>



// WEBPACK FOOTER //
// SectionAdventureFeed.vue?68fa1836